import { HttpParams } from "@angular/common/http";
import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { AuthService } from "../../core/services/auth/auth.service";
import { CommonConfirmDialogComponent } from "../common-confirm-dialog/common-confirm-dialog.component";
import { PartitionConfirmDialogInfo } from "../../core/data/models/partition-confirm-dialog-info";
import { PartitionsApi } from "src/app/core/api/partitions.api";

@Component({
  selector: "app-partition-delete-dialog",
  templateUrl: "./partition-delete-dialog.component.html",
  styleUrls: ["./partition-delete-dialog.component.scss"],
})
export class PartitionDeleteDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,

    public partitionConfirmDialog: MatDialog,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<PartitionDeleteDialogComponent>,
    public auth: AuthService,
    private router: Router,

    private partitionsApi: PartitionsApi
  ) {}

  ngOnInit() {}

  onClickConfirm() {
    if (!navigator.onLine) {
      alert("ネットワーク接続を確認してください");
      return;
    }

    const messageInfo = new PartitionConfirmDialogInfo(
      "削除確認",
      "区画を削除します。よろしいですか。"
    );
    const confirmDialog = this.partitionConfirmDialog.open(
      CommonConfirmDialogComponent,
      {
        width: "400px",
        data: messageInfo,
      }
    );

    confirmDialog.afterClosed().subscribe((result) => {
      if (result === "Yes") {
        // APIコールして登録処理
        const patchPartitionUrl = `${environment.apiUrl}/partitions/partition_info/0/${this.data.partitionInfo.id}`;
        let params = new HttpParams();

        this.partitionsApi
          .deletePartition(this.data.partitionInfo.id, params)
          .subscribe((response) => {
            this.dialogRef.close("close");
          });
      }
    });
  }
}
